var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [_c("event-tree-grid")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }